<template>
  <div @click="back">
    返回之前页
    {{routeName}}
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name:'Errorpage',
    computed: {
      ...mapState('common/promise', ['routeName'])
    },
    methods: {
      back() {
        this.$router.replace({
          name: this.routeName
        })
      }
    }
  }
</script>

<style scoped="scoped" lang="scss">
  div {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/pages/404/404.vue